/**
 * Inline spinner for buttons in their loading state (v0.4.0 polish #32).
 *
 * Inherits color from currentColor so it works inside btn-primary (text-ink-0
 * on cyan), btn-secondary (text-fg-0 on ink-2), btn-danger, etc. without a
 * variant for each.
 */
export function Spinner({
  size = 14,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={`spinner ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
